import { isFunction } from "./utils.ts";

type EventCallback = (event: unknown) => void;

export default class EventHandler {
  private _listeners: Record<string, EventCallback[]>;

  constructor() {
    this._listeners = {};
  }

  notifyListeners = (type: string, event: unknown): void => {
    if (!this._listeners[type]) return;
    const listeners = this._listeners[type];
    for (let index = 0; index < listeners.length; index++) {
      listeners[index](event);
    }
  };

  registerForEvent = (type: string, callback: EventCallback): void => {
    if (!isFunction(callback)) return;
    const listeners = this._listeners[type] ?? [];
    listeners.push(callback);
    this._listeners[type] = listeners;
  };

  unregisterFromEvent = (type: string, callback: EventCallback): void => {
    if (this._listeners[type]) {
      this._listeners[type] = this._listeners[type].filter(
        (listener) => listener !== callback
      );
    }
  };

  tearDown = (): void => {
    this._listeners = {};
  };
}
